import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DocumentsListingComponent} from './documents-listing.component';
import {BreadcrumbModule} from "primeng/breadcrumb";
import {ToastModule} from "primeng/toast";
import {TableModule} from "primeng/table";
import { DocumentsListingTabletComponent } from './documents-listing-tablet/documents-listing-tablet.component';
import {BadgeModule} from 'primeng/badge';
import {RippleModule} from "primeng/ripple";


@NgModule({
    declarations: [DocumentsListingComponent, DocumentsListingTabletComponent],
    imports: [
        CommonModule,
        BreadcrumbModule,
        ToastModule,
        TableModule,
        BadgeModule,
        RippleModule
    ]
})
export class DocumentsListingModule {
}
